import React, { useContext, useEffect } from 'react'
import { HeadingContext } from '../context/HeadingContext';

function Locate() {

  const { setHeading } = useContext(HeadingContext);

  useEffect(() => {
    setHeading('Location');
  }, [setHeading]);
  return (
    <div>Location</div>
  )
}

export default Locate